import React from 'react';
import { groupIdToTitle } from '../utils/groupTitles';
import { formatRuDate } from '../utils/ruDateUtils';

// Экспортируем для обратной совместимости (если где-то используется импорт из этого файла)
export { groupIdToTitle };

// Вспомогательная функция для формирования ссылки на пост ВКонтакте
const getVkPostLink = (groupId, postId) => {
  if (!groupId || !postId) return null;
  const vkGroupId = groupId > 0 ? -groupId : groupId; // если без минуса — добавляем
  return `https://vk.com/wall${vkGroupId}_${postId}`; // Исправлено: убран лишний пробел
};

const ChartPointDataModal = ({ date, rows, onClose, loading = false, error = null, groupByPost = false, postCards = false, title = '' }) => {
  if (!date) return null;

  // Определяем уникальные ключи из всех объектов в rows
  const allKeys = new Set();
  rows?.forEach(row => {
    Object.keys(row).forEach(key => allKeys.add(key));
  });

  // Преобразуем Set в массив и сортируем для стабильности (по желанию)
  const headers = Array.from(allKeys).sort();

  // Опционально: исключить определенные поля из отображения в таблице
  // const excludedKeys = ['someInternalField']; // Пример
  // const displayHeaders = headers.filter(key => !excludedKeys.includes(key));

  // Используем все ключи или отфильтрованные, например, displayHeaders
  const displayHeaders = groupByPost
    ? headers.filter((key) => !['Группа', 'ID поста', 'Ссылка на пост'].includes(key))
    : headers;

  const rowGroups = groupByPost
    ? Array.from((rows || []).reduce((groups, row) => {
      const key = row['Ссылка на пост'] || `${row['Группа']}:${row['ID поста']}`;
      if (!groups.has(key)) groups.set(key, { key, post: row, rows: [] });
      groups.get(key).rows.push(row);
      return groups;
    }, new Map()).values())
    : [{ key: 'all', rows: rows || [] }];

  // Функция для получения отображаемого заголовка
  const getDisplayHeader = (key) => {
    // Можете добавить маппинг ключей на русские названия
    const headerMap = {
      // 'author_id': 'Автор',
      // 'group_id': 'Группа',
      // 'post_id': 'Пост',
      // 'intensity': 'Значение',
      // 'dict': 'Тематика',
      // 'link': 'Ссылка' // Если link добавляется в row
    };
    return headerMap[key] || key;
  };

  // Функция для получения отображаемого значения ячейки
  const getDisplayValue = (row, key) => {
    // Если колонка про "Ссылку" — рендерим кликабельную гиперссылку по значению
    if (typeof key === 'string' && (key.includes('Ссылка')|| key.includes('Автор'))) {
      const url = row[key];
      if (typeof url === 'string' && url && url !== '-') {
        return (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#169af7',
              textDecoration: 'none',
              fontSize: '13px',
            }}
          >
            Открыть
          </a>
        );
      }
      return <span style={{ color: '#999', fontSize: '13px' }}>-</span>;
    }

    if (key === 'group_id') {
      return groupIdToTitle[row[key]] || row[key];
    }
    if (key === 'link') {
      // Если вы хотите отображать ссылку как отдельный столбец, добавьте её в row перед обработкой
      const link = getVkPostLink(row['group_id'], row['post_id']);
      if (link) {
        return (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#169af7',
              textDecoration: 'none',
              fontSize: '13px',
            }}
          >
            Открыть
          </a>
        );
      }
      return <span style={{ color: '#999', fontSize: '13px' }}>-</span>;
    }
    // Обработка других специфических значений можно добавить здесь
    return row[key] !== undefined && row[key] !== null ? row[key] : '-';
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: 'white',
          borderRadius: 12,
          padding: 0,
          minWidth: postCards ? 0 : 600,
          maxWidth: groupByPost || postCards ? '95vw' : undefined,
          width: groupByPost ? '95vw' : postCards ? 'min(800px, 95vw)' : undefined,
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        }}
      >
        {/* Заголовок с крестиком */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 20px',
            borderBottom: '1px solid #eee',
            borderRadius: '12px 12px 0 0',
            background: 'white',
            flexShrink: 0,
            position: 'relative',
            zIndex: 2,
          }}
        >
          <div>
            <h3 style={{ margin: 0, fontSize: '16px', color: '#333' }}>
              {postCards ? 'Посты' : 'Данные'} за {formatRuDate(date)}{title ? ` · ${title}` : ''}
            </h3>
            {postCards && !loading && !error && (
              <span style={{ color: '#666', fontSize: 13 }}>Найдено постов: {rows?.length || 0}</span>
            )}
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: '#999',
              width: 30,
              height: 30,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => (e.target.style.color = '#333')}
            onMouseLeave={(e) => (e.target.style.color = '#999')}
          >
            ×
          </button>
        </div>

        {/* Таблица */}
        <div style={{ padding: '0 20px 20px', background: 'white', overflow: 'auto', minHeight: 0, flex: 1 }}>
          {loading ? (
            <p>Данные загружаются...</p>
          ) : error ? (
            <p className="text-danger">{error}</p>
          ) : postCards && rows?.length > 0 ? (
            <div style={{ display: 'grid', gap: 12, paddingTop: 12 }}>
              {rows.map((row, index) => (
                <article key={`${row['Ссылка на пост']}-${index}`} style={{ border: '1px solid #e2e8f0', borderRadius: 10, padding: 16, background: '#fff' }}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 16px', alignItems: 'center', color: '#475569', fontSize: 13 }}>
                    <strong style={{ color: '#1e293b' }}>{row['Группа']}</strong>
                    <span>{formatRuDate(row['Дата']?.slice(0, 10))}</span>
                    <span>Пост №{row['ID поста']}</span>
                    {Number.isFinite(Number(row['Уверенность модели'])) && (
                      <span>Уверенность: {(Number(row['Уверенность модели']) * 100).toFixed(1)}%</span>
                    )}
                  </div>
                  <p style={{ margin: '12px 0', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', lineHeight: 1.5, color: '#1e293b' }}>
                    {row['Текст'] || 'Текст поста отсутствует'}
                  </p>
                  <a href={row['Ссылка на пост']} target="_blank" rel="noopener noreferrer">Открыть пост ВКонтакте</a>
                </article>
              ))}
            </div>
          ) : rows?.length > 0 ? (
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '14px',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
              }}
            >
              <thead>
                <tr style={{ background: '#f8f9fa' }}>
                  {displayHeaders.map((header, idx) => (
                    <th
                      key={idx}
                      style={{
                        padding: '12px 8px',
                        textAlign: 'left',
                        borderBottom: '2px solid #e0e0e0',
                        fontWeight: '600',
                        color: '#555',
                        minWidth: '100px', // Можно установить минимальную ширину
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        background: '#f8f9fa',
                      }}
                    >
                      {getDisplayHeader(header)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rowGroups.map((group) => (
                  <React.Fragment key={group.key}>
                    {groupByPost && (
                      <tr style={{ background: '#eaf2ff' }}>
                        <td colSpan={displayHeaders.length} style={{ padding: '12px 10px', fontWeight: 600 }}>
                          {group.post['Группа']} · Пост №{group.post['ID поста']} · Комментариев и ответов: {group.rows.length}{' '}
                          <a href={group.post['Ссылка на пост']} target="_blank" rel="noopener noreferrer">Открыть пост</a>
                        </td>
                      </tr>
                    )}
                    {group.rows.map((row, i) => (
                      <tr
                        key={`${group.key}-${i}`}
                        style={{
                          borderBottom: '1px solid #f0f0f0',
                          transition: 'background-color 0.2s',
                        }}
                        onMouseEnter={(e) => (e.target.style.backgroundColor = '#f9f9f9')}
                        onMouseLeave={(e) => (e.target.style.backgroundColor = 'transparent')}
                      >
                        {displayHeaders.map((header, j) => (
                          <td
                            key={j}
                            style={{ padding: '10px 8px', verticalAlign: 'middle', maxWidth: '500px' }}
                          >
                            {getDisplayValue(row, header)}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          ) : (
            <p
              style={{
                textAlign: 'center',
                color: '#666',
                fontStyle: 'italic',
                padding: '40px 0',
              }}
            >
              Нет данных за эту дату
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChartPointDataModal;
